import { cva, type VariantProps } from "./style.utils";

export type CommandVariants = VariantProps<typeof commandVariants>;

export const commandVariants = cva({
  base: [
    // layout
    "flex size-full flex-col overflow-hidden",
    // radii
    "rounded-[inherit]",
    // background
    "bg-white",
    // foreground
    "text-shade-100",
  ],
});

// -----------------------------------------------------------------------------

export type CommandDialogCommandVariants = VariantProps<
  typeof commandDialogCommandVariants
>;

export const commandDialogCommandVariants = cva({
  base: [
    // children: input
    "[&_[data-slot=cmdk-input-wrapper]]:p-8px",
    "[&_[data-slot=cmdk-input-wrapper]]:pb-0",
    // children: group foreground
    "[&_[cmdk-group]]:px-8px",
    "[&_[cmdk-group-heading]]:px-10px",
    "[&_[cmdk-group-heading]]:py-8px",
    // children: group items
    "[&_[cmdk-item]]:px-10px",
    "[&_[cmdk-item]]:py-8px",
  ],
});

// -----------------------------------------------------------------------------

export type CommandInputWrapperVariants = VariantProps<
  typeof commandInputWrapperVariants
>;

export const commandInputWrapperVariants = cva({
  base: "p-4px pb-0",
});

// -----------------------------------------------------------------------------

export type CommandListVariants = VariantProps<typeof commandListVariants>;

export const commandListVariants = cva({
  base: "max-h-300px overflow-y-auto overflow-x-hidden",
});

// -----------------------------------------------------------------------------

export type CommandEmptyVariants = VariantProps<typeof commandEmptyVariants>;

export const commandEmptyVariants = cva({
  base: [
    // layout
    "py-24px",
    // foreground
    "text-center text-sm",
  ],
});

// -----------------------------------------------------------------------------

export type CommandGroupVariants = VariantProps<typeof commandGroupVariants>;

export const commandGroupVariants = cva({
  base: [
    // layout
    "overflow-hidden p-4px",
    // children layout
    "[&_[cmdk-group-heading]]:px-8px",
    "[&_[cmdk-group-heading]]:py-6px",
    // children foreground
    "[&_[cmdk-group-heading]]:text-xs",
    "[&_[cmdk-group-heading]]:font-semibold",
  ],
});

// -----------------------------------------------------------------------------

export type CommandSeparatorVariants = VariantProps<
  typeof commandSeparatorVariants
>;

export const commandSeparatorVariants = cva({
  base: [
    // layout
    "-mx-4px my-4px h-1px",
    // background
    "bg-shade-10",
  ],
});

// -----------------------------------------------------------------------------

export type CommandItemVariants = VariantProps<typeof commandItemVariants>;

export const commandItemVariants = cva({
  base: [
    // layout
    "flex items-center gap-8px px-8px py-6px",
    // positioning
    "relative",
    // foreground
    "cursor-default select-none text-sm",
    // radii
    "rounded",
    // children
    "[&_svg]:pointer-events-none [&_svg]:size-16px [&_svg]:shrink-0",
    // focus unset outline
    "outline-none",
    // focus/hover/active
    // `data-[selected=true]` is the hover/active state
    "data-[selected=true]:bg-neutral-100/10",
    "data-[selected=true]:text-shade-100",
    // disabled
    "data-[disabled=true]:pointer-events-none",
    "data-[disabled=true]:opacity-50",
  ],
});

// -----------------------------------------------------------------------------

export type CommandShortcutVariants = VariantProps<
  typeof commandShortcutVariants
>;

export const commandShortcutVariants = cva({
  base: [
    // layout
    "ml-auto",
    // foreground
    "text-xs tracking-widest text-shade-80",
  ],
});
